import { CreationType } from 'src/containers/PublishProjectDrawer/types';
import {
  Project,
  ProjectsState,
  PublishHistory,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type OldPublishHistory = Omit<
  PublishHistory,
  'csvResourceHistoriesById' | 'vgResourceHistoriesById'
> & {
  csvResourceHistoriesById: Record<
    string,
    {
      creationType: CreationType;
      namedGraphIri: string;
    }
  >;
  vgResourceHistoriesById: Record<
    string,
    {
      virtualGraphName: string;
    }
  >;
};

/**
 * Migration to add shouldPublish to CSV and VG Publish History
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v43 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v43Projects(prevState.projects);
  }

  return nextState;
};

const v43Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<
      string,
      Project & { publishHistory: OldPublishHistory }
    >
  ).forEach(([projectId, project]) => {
    const { publishHistory } = project;

    // Add shouldPublish: true to all CSV resource histories
    const updatedCsvResourceHistoriesById: Record<
      string,
      {
        creationType: CreationType;
        namedGraphIri: string;
        shouldPublish: boolean;
      }
    > = {};

    Object.entries(publishHistory.csvResourceHistoriesById || {}).forEach(
      ([key, history]) => {
        updatedCsvResourceHistoriesById[key] = {
          ...history,
          shouldPublish: true,
        };
      }
    );

    // Add shouldPublish: true to all virtual graph resource histories
    const updatedVgResourceHistoriesById: Record<
      string,
      {
        virtualGraphName: string;
        shouldPublish: boolean;
      }
    > = {};

    Object.entries(publishHistory.vgResourceHistoriesById || {}).forEach(
      ([key, history]) => {
        updatedVgResourceHistoriesById[key] = {
          ...history,
          shouldPublish: true,
        };
      }
    );

    projectsById[projectId] = {
      ...project,
      publishHistory: {
        ...publishHistory,
        csvResourceHistoriesById: updatedCsvResourceHistoriesById,
        vgResourceHistoriesById: updatedVgResourceHistoriesById,
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
